import Hero from '../components/Hero';
import Features from '../components/Features';
import InteractiveDemo from '../components/InteractiveDemo';
import Benefits from '../components/Benefits';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';
import Seo from '../components/Seo';
import '../App.css';

export default function HomePage() {
  return (
    <div className="app">
      <Seo
        title="Recvisit — учет посещаемости через QR‑коды"
        description="SaaS‑сервис учета посещаемости сотрудников на объектах через QR‑коды. Быстрое внедрение, защита от подделки, удобная панель управления."
        canonicalPath="/"
      />
      <Hero />
      <Features />
      <div className="container">
        <InteractiveDemo />
      </div>
      <Benefits />
      <ContactForm />
      <Footer />
    </div>
  );
}

